



import React from 'react'
import './ContactSuccess.css'




const ContactSuccess:React.FC = () => {



  return (
    <div className=' w-screen overflow-hidden p-10 '>
        <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
        <div className='sm:text-lg md:text-lg lg:text-3xl xl:text-3xl  text-black font-mono '><h3>Thank You Our Support Team Reach Out To You </h3></div>


        </div>
      
    </div>
  )
}

export default ContactSuccess
